// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"806":"ea3f2642","973":"0a8157ab"}[chunkId] + ".chunk.css";
};